export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_SURVEY_ID = "SET_SURVEY_ID";
export const SET_LEAD_ID = "SET_LEAD_ID";
export const GET_LEAD_FROM_EMAIL = "GET_LEAD_FROM_EMAIL";
export const SET_UPDATED_AT = "SET_UPDATED_AT";
export const SET_CREATED_AT = "SET_CREATED_AT";
export const RESET_SURVEY_ID = "RESET_SURVEY_ID";
export const RESET_STATE = "RESET_STATE";
export const RESET_LEAD_LIST = "RESET_LEAD_LIST";
export const PUSH_LEAD = "PUSH_LEAD";



// WEBPACK FOOTER //
// ./src/store/lead/mutations.js